import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { MailIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

import type { IdeaTeamStartChatProps } from "./types";

const IdeaTeamStartChat = ({
  idea,
  onMessageThreadSelected,
  style,
  size,
  fluid,
  basic,
}: IdeaTeamStartChatProps) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const forId = idea?._id;
  const forType = "idea";
  const { t } = useTranslation();
  const selectThread = (threadId: string) => {
    dispatch(actions.messages.selectThread(threadId));
    onMessageThreadSelected?.(threadId);
  };

  const startChat = () => {
    if (!user?._id) {
      return;
    }
    const currentUser = user._id;
    let name = idea?.name ?? "";

    api.messages.findThreads(
      { forType, forId },
      (data) => {
        if (data.threads.length && data.threads[0]?._id) {
          selectThread(data.threads[0]._id);
        } else {
          const { user: ideaOwner, collaborators = [] } = idea;
          const chatUsers =
            currentUser === ideaOwner
              ? collaborators
              : [
                  ideaOwner,
                  ...collaborators.filter((c: string) => c !== currentUser),
                ];
          if (name.length > 50) {
            name = `${name.substring(0, 50)}...`;
          }
          api.messages.createThread(
            {
              users: chatUsers,
              name: `Idea Team Chat - ${name}`,
              forType,
              forId,
            },
            (data) => {
              selectThread(data._id);
            },
            (err) => toast.error(err.message),
          );
        }
      },
      (err) => {
        toast.error(err.message);
      },
    );
  };

  return (
    <Button
      size={size}
      onClick={() => startChat()}
      style={style}
      fluid={fluid}
      color={!basic ? "primary" : undefined}
      variant={basic ? "outline" : "regular"}
    >
      <Icon icon={MailIcon} />
      {`Message ${t("generic.idea")} team`}
    </Button>
  );
};

export default IdeaTeamStartChat;
